import React, {useContext} from 'react';
import {SettingsContext} from '~/src/components/context/SettingsContext';
import {SiteArea} from '~/src/utilities/constants/navigation';

const Boomerang = () => {
    const {siteArea} = useContext(SettingsContext);

    if (siteArea === SiteArea.LIFESTYLE) {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 26">
                <path d="M.099 24.066L28.246.448l.138-.165.029.024.03-.024.137.165 28.148 23.618-1.286 1.532-27.03-22.68-27.028 22.68L.1 24.066z" />
            </svg>
        );
    }
    return (
        <svg viewBox="0 0 16 11">
            <path fill="none" d="M1 9.5l7-7 7 7" />
        </svg>
    );
};

export default Boomerang;
